import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router';
import type { ServiceDefinition } from '../../config/services';

export function ServiceCard({ service }: { service: ServiceDefinition }) {
  return (
    <article className="service-card-v2">
      <p className="eyebrow">{service.shortName}</p>
      <h3>{service.name}</h3>
      <p>{service.cardSummary}</p>
      <Link className="service-card-v2__link link-underline icon-nudge" to={`/services/${service.slug}`}>
        View service <ArrowUpRight aria-hidden="true" size={17} />
      </Link>
    </article>
  );
}
